<template>
  <div id="report-detail">
    <v-row justify="center">
      <v-col class="text-center">
        <h3>รายงานภาษีขาย</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-center">
        <span class="text-title-month">ประจำเดือน</span>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="dateSelect"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="button-select"
              width="200px"
              height="40px"
              v-model="dateSelect"
              v-bind="attrs"
              style="border: solid 1px #c4c4c4; border-radius: 10px; justify-content: space-between; box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0); font-size: 16px;"
              v-on="on"
            >
              <div>
                <span>{{ getMontFromCalender(dateSelect) }}</span>
              </div>
              <img src="/images/icon-angle-down.svg" style="max-width: 14px; max-height: 14px;" alt="dropdown" />
            </v-btn>
          </template>
          <v-date-picker v-model="dateSelect" type="month" no-title scrollable locale="th">
            <v-spacer></v-spacer>
            <v-btn text color="#c84f99" @click="menu = false">Cancel</v-btn>
            <v-btn text color="#c84f99" @click="setSelectDate(dateSelect)">OK</v-btn>
          </v-date-picker>
        </v-menu>
        <v-btn
          text
          class="tw-px-4 tw-py-2 tw-ml-4 tw-rounded-md tw-relative tw-text-light-green hover:tw-bg-light-green hover:tw-text-white"
          @click="exportReport"
        >
          <v-icon left>mdi-file-document-multiple</v-icon>
          ส่งออกข้อมูล CSV
        </v-btn>
        <v-btn
          text
          class="tw-px-4 tw-py-2 tw-ml-2 tw-rounded-md tw-relative tw-text-light-green hover:tw-bg-light-green hover:tw-text-white"
          @click="exportReportExcel"
        >
          <v-icon left>mdi-file-excel</v-icon>
          ส่งออกข้อมูล Excel
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="2" class="col-response">
        <b>ชื่อผู้ประกอบการ</b>
      </v-col>
      <v-col md="5" class="col-response">{{ companyDetail.nameTH }}</v-col>
      <v-col md="2" class="col-response">
        <b>เลขที่ประจำตัวผู้เสียภาษี</b>
      </v-col>
      <v-col>{{ companyDetail.taxID }}</v-col>
    </v-row>
    <v-row>
      <v-col md="2" class="col-response">
        <b>ชื่อสถานประกอบการ</b>
      </v-col>
      <v-col md="5" class="col-response">{{ companyDetail.nameTH }}</v-col>
      <v-col>
        <v-radio-group :value="selectedBranch" disabled row>
          <v-radio label="สำนักงานใหญ่" value="00000"></v-radio>
          <v-radio label="สาขา" :value="selectedBranch !== '00000' && selectedBranch"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="2" class="col-response-non" />
      <v-col md="10" class="col-response">{{ this.getAddress(companyDetail.address) }}</v-col>
    </v-row>
    <v-row class="mt-3">
      <v-col style="overflow-x:auto;">
        <table style="width:100%; margin-bottom: 10px;">
          <thead>
            <tr class="row-header">
              <th rowspan="2" class="text-center">ลำดับที่</th>
              <th colspan="2" class="text-center">ใบกำกับภาษี</th>
              <th rowspan="2" class="text-center">Ref.</th>
              <th rowspan="2" class="text-center">ชื่อผู้ซื้อ / ชื่อบริษัท</th>
              <th rowspan="2" class="text-center">เลขผู้เสียภาษี</th>
              <th colspan="2" class="text-center">สถานประกอบการ</th>
              <th rowspan="2" class="text-center">มูลค่าที่นำมาคิดภาษีมูลค่าเพิ่ม</th>
              <th rowspan="2" class="text-center">ภาษีมูลค่าเพิ่ม</th>
              <th rowspan="2" class="text-center">ยอดรวมทั้งหมด</th>
              <th rowspan="2" class="text-center">หมายเหตุ</th>
            </tr>
            <tr class="row-header">
              <th class="text-center">วันที่</th>
              <th class="text-center">เลขที่</th>
              <th class="text-center">สำนักงานใหญ่</th>
              <th class="text-center">สาขาที่</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loadingData">
              <td colspan="11">
                <v-progress-linear indeterminate color="#6ec39b"></v-progress-linear>
              </td>
            </tr>
           <tr v-for="(doc, index) in docList.filter(doc => doc['@DocType'] !== 5)" :key="doc.id">
            <!-- <tr v-for="(doc, index) in docList" :key="doc.id"> -->
              <td class="text-center">{{ new Intl.NumberFormat().format(index + 1) }}</td>
              <td class="text-center">{{ getDateWithFormat(doc['ED.IssueDateTime']) }}</td>
              <td class="text-center">{{ doc['ED.ID'] }}</td>
              <td class="text-center">{{getRefDoc(doc['SCTT.AHTA.ARD'])}}</td>
              <td>{{ doc['SCTT.AHTA.BTP.Name'] }}</td>
              <td class="text-center">{{ doc['SCTT.AHTA.BTP.STR.ID'].slice(0, 13) || '-' }}</td>
              <td
                class="text-center"
              >{{ (doc['@BuyerBranchID'] && doc['@BuyerBranchID'] === "00000") ? doc['@BuyerBranchID'] : "-" }}</td>
              <td
                class="text-center"
              >{{ (doc['@BuyerBranchID'] && doc['@BuyerBranchID'] !== "00000") ? doc['@BuyerBranchID'] : "-" }}</td>
              <td class="text-right">
              {{ doc['@DocData'].docStatus === 'C' ? getFormatAmount(-Math.abs(doc['SCTT.AHTS.STSHMS.TaxBasisTotalAmount'])) : getFormatAmount(doc['SCTT.AHTS.STSHMS.TaxBasisTotalAmount']) }}
              </td>
              <td class="text-right">
                {{ doc['@DocData'].docStatus === 'C' ? getFormatAmount(-Math.abs(doc['SCTT.AHTS.STSHMS.TaxTotalAmount'])) : getFormatAmount(doc['SCTT.AHTS.STSHMS.TaxTotalAmount']) }}
              </td>
              <td class="text-right">
                {{ doc['@DocData'].docStatus === 'C' ? getFormatAmount(-Math.abs(doc['SCTT.AHTS.STSHMS.GrandTotalAmount'])) : getFormatAmount(doc['SCTT.AHTS.STSHMS.GrandTotalAmount']) }}
              </td>
              <td class="text-right">
                {{ doc['@DocData'].docStatus === 'C' ? "ยกเลิก" : "" }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="row-header-total">
              <td colspan="8" class="text-right title-total">ยอดขายรวมตาม Tax report</td>
              <td colspan="3"></td>
              <td></td>
            </tr>
            <tr>
              <td colspan="8" class="text-right">ยอดขาย 7%</td>
              <td class="text-right">{{ getFormatAmount(summaryReport.sumTaxableAmount) }} </td>
              <td class="text-right">{{ getFormatAmount(summaryReport.sumTaxableTax) }}</td>
              <td class="text-right">{{ getFormatAmount(summaryReport.sumTaxableAllAmount) }}</td>
              <td></td>
            </tr>
            <tr>
              <td colspan="8" class="text-right">ยอดขายได้รับการยกเว้นภาษี</td>
              <td class="text-right">{{ getFormatAmount(summaryReport.sumAmount) }}</td>
              <td class="text-right">{{ getFormatAmount(summaryReport.sumTax) }}</td>
              <td class="text-right">{{ getFormatAmount(summaryReport.sumAllAmount) }}</td>
              <td></td>
            </tr>
            <tr>
              <td colspan="9" class="text-right total-text">{{ getFormatAmount(summaryReport.grandTotalAmount) }}</td>
              <td class="text-right total-text">{{ getFormatAmount(summaryReport.grandTotalTax) }}</td>
              <td class="text-right total-text">{{ getFormatAmount(summaryReport.grandTotalAllAmount) }}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from "moment"
import "moment/locale/th"
import { mapState } from "vuex"
import "moment/locale/th"
import formatTwoDecimal from "@/libs/formatTwoDecimal"
import libCSV from "@/libs/libCSV"
import * as XLSX from "xlsx";

moment.locale("th")

export default {
  name: "ReportDetail",
  computed: mapState({
    companyDetail: (state) => state.companies.companyDetail,
    docList: (state) => state.docs.docList,
    loadingData: (state) => state.docs.loading,
    summaryReport: (state) => state.docs.summaryReport,
    selectedBranch: (state) => state.companies.selectedBranch,
  }),
  data() {
    return {
      menu: false,
      dateSelect: new Date().toISOString().substr(0, 7),
    }
  },
  created() {
    this.getData()
  },
  methods: {
    exportReport() {
      const rows = [
        [
          "ลำดับที่",
          "วันที่",
          "เลขที่",
          "Ref.",
          "ชื่อผู้ซื้อ/ชื่อบริษัท",
          "เลขผู้เสียภาษี",
          "สำนักงานใหญ่",
          "สาขาที่",
          "มูลค่าที่นำมาคิดภาษีมูลค่าเพิ่ม",
          "ภาษีมูลค่าเพิ่ม",
          "ยอดรวมทั้งหมด",

        ],
      ]

      let order = 1

      for (const doc of this.docList) {
        if (doc["@DocType"] !== 5) {

          const isNegative = (doc['@DocData']?.docStatus === 'C' && doc["@DocType"] === 7) ? -1 : 1;

        rows.push([
          order,
          this.getDateWithFormat(doc["ED.IssueDateTime"]),
          doc["ED.ID"],
          this.getRefDoc(doc["SCTT.AHTA.ARD"]),
          doc["SCTT.AHTA.BTP.Name"],
          doc["SCTT.AHTA.BTP.STR.ID"].slice(0,13) || "-",
          doc["@BuyerBranchID"] && doc["@BuyerBranchID"] === "00000" ? doc["@BuyerBranchID"] : "-",
          doc["@BuyerBranchID"] && doc["@BuyerBranchID"] !== "00000" ? doc["@BuyerBranchID"] : "-",
          libCSV.stangToTHB(doc["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"] * isNegative),
        libCSV.stangToTHB(doc["SCTT.AHTS.STSHMS.TaxTotalAmount"] * isNegative),
        libCSV.stangToTHB(doc["SCTT.AHTS.STSHMS.GrandTotalAmount"] * isNegative)

        ])
        order += 1;

        }
      }

      rows.push([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "ยอดขาย 7%",
        libCSV.stangToTHB(this.summaryReport.sumTaxableAmount),
        libCSV.stangToTHB(this.summaryReport.sumTaxableTax),
        libCSV.stangToTHB(this.summaryReport.sumTaxableAllAmount),
      ])

      rows.push([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "ยอดขายได้รับการยกเว้นภาษี",
        libCSV.stangToTHB(this.summaryReport.sumAmount),
        libCSV.stangToTHB(this.summaryReport.sumTax),
        libCSV.stangToTHB(this.summaryReport.sumAllAmount),
      ])

      rows.push([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        libCSV.stangToTHB(this.summaryReport.grandTotalAmount),
        libCSV.stangToTHB(this.summaryReport.grandTotalTax),
        libCSV.stangToTHB(this.summaryReport.grandTotalAllAmount),
      ])

      libCSV.exportCSV(`Reports_${this.dateSelect}.csv`, rows)
    },
    exportReportExcel() {
  const rows = [
    [
      "ลำดับที่",
      "วันที่",
      "เลขที่",
      "Ref.",
      "ชื่อผู้ซื้อ/ชื่อบริษัท",
      "เลขผู้เสียภาษี",
      "สำนักงานใหญ่",
      "สาขาที่",
      "มูลค่าที่นำมาคิดภาษีมูลค่าเพิ่ม",
      "ภาษีมูลค่าเพิ่ม",
      "ยอดรวมทั้งหมด",
      "หมายเหตุ"
    ],
  ];

  let order = 1;

    for (const doc of this.docList) {
      if (doc["@DocType"] !== 5) {
    rows.push([
    { v: order.toString(), t: "s" },
      { v: this.getFormatDate(doc["ED.IssueDateTime"]), t: "s" }, // วันที่
      { v: doc["ED.ID"], t: "s" }, // เลขที่
      { v: this.getRefDoc(doc["SCTT.AHTA.ARD"]), t: "s" }, // Ref.
      { v: doc["SCTT.AHTA.BTP.Name"], t: "s" }, // ชื่อผู้ซื้อ/บริษัท
      { v: doc["SCTT.AHTA.BTP.STR.ID"].slice(0, 13) || "-", t: "s" }, // เลขผู้เสียภาษี
      { v: doc["@BuyerBranchID"] && doc["@BuyerBranchID"] === "00000" ? doc["@BuyerBranchID"] : "-", t: "s" }, // สำนักงานใหญ่
      { v: doc["@BuyerBranchID"] && doc["@BuyerBranchID"] !== "00000" ? doc["@BuyerBranchID"] : "-", t: "s" }, // สาขาที่
      { v: (doc['@DocData']?.docStatus === 'C' && doc["@DocType"] === 7)
    ? -this.formatTHBWithSign(doc["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"])
    : this.formatTHBWithSign(doc["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"]), t: "n" }, // มูลค่าภาษีมูลค่าเพิ่ม

{ v: (doc['@DocData']?.docStatus === 'C' && doc["@DocType"] === 7)
    ? -this.formatTHBWithSign(doc["SCTT.AHTS.STSHMS.TaxTotalAmount"])
    : this.formatTHBWithSign(doc["SCTT.AHTS.STSHMS.TaxTotalAmount"]), t: "n" }, // ภาษีมูลค่าเพิ่ม

{ v: (doc['@DocData']?.docStatus === 'C' && doc["@DocType"] === 7)
    ? -this.formatTHBWithSign(doc["SCTT.AHTS.STSHMS.GrandTotalAmount"])
    : this.formatTHBWithSign(doc["SCTT.AHTS.STSHMS.GrandTotalAmount"]), t: "n" }, // ยอดรวมทั้งหมด

      { v: (doc['@DocData']?.docStatus === 'C' && doc["@DocType"] === 7) ? "ยกเลิก" : "", t: "s" }

    ]);

    order += 1;

      }

  }




  rows.push([
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "ยอดขาย 7%",
    { v: this.stangToTHB(this.summaryReport.sumTaxableAmount), t: "n" },
    { v: this.stangToTHB(this.summaryReport.sumTaxableTax), t: "n" },
    { v: this.stangToTHB(this.summaryReport.sumTaxableAllAmount), t: "n" },
  ]);

  rows.push([
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "ยอดขายได้รับการยกเว้นภาษี",
    { v: this.stangToTHB(this.summaryReport.sumAmount), t: "n" },
    { v: this.stangToTHB(this.summaryReport.sumTax), t: "n" },
    { v: this.stangToTHB(this.summaryReport.sumAllAmount), t: "n" },
  ]);

  rows.push([
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    { v: this.stangToTHB(this.summaryReport.grandTotalAmount), t: "n" },
    { v: this.stangToTHB(this.summaryReport.grandTotalTax), t: "n" },
    { v: this.stangToTHB(this.summaryReport.grandTotalAllAmount), t: "n" },
  ]);

  console.log("Data rows populated:", rows); // Debugging statement


  const worksheet = XLSX.utils.aoa_to_sheet(rows);


  Object.keys(worksheet).forEach((cell) => {
    if (worksheet[cell].t === "n") {
      worksheet[cell].z = "#,##0.00"; // กำหนดรูปแบบตัวเลขใน Excel
    }
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, `Reports_${this.dateSelect}`);

  const fileName = `Reports_${this.dateSelect}.xlsx`;

  XLSX.writeFile(workbook, fileName);

  console.log("Excel file download triggered"); // Debugging statement
},


    stangToTHB(v) {
      return (v / 100).toFixed(2);
    },

    formatTHBWithSign(v, doc) {
  if (doc && doc['@DocType'] === 7) {
    return (-Math.abs(v) / 100).toFixed(2); // แปลงยอดเป็นลบ
  }
  return (v / 100).toFixed(2); // กรณีปกติ
},
    getFormatAmount(amount) {
      return formatTwoDecimal(amount)
    },
    getMontFromCalender: function (date) {
      return moment(date).add(543, "year").format("MMMM YYYY")
    },
    setSelectDate: function (dateSelect) {
      this.$refs.menu.save(dateSelect)
      this.dateSelect = dateSelect
      this.getData()
    },
    getData: function () {
      let companyID = this.$route.params.companyId
      let startDate = moment(this.dateSelect).startOf("day")
      let endDate = moment(this.dateSelect).endOf("month").endOf("day")
      this.$store.dispatch("companies/getCompany", { companyID })
      this.$store.dispatch("docs/getListByMonth", {
        companyID,
        startDate,
        endDate,
        reportBranchType: this.selectedBranch,
      })
    },
    getDateWithFormat: function (date) {
      return moment(new Date(date)).add(543, "year").format("Do MMM YY")
    },

    getFormatDate: function (date) {
    return moment(new Date(date)).format("DD/MM/YYYY");
    },

    getAddress: function (address) {
      let showAddress = ""
      if (!address) {
        return showAddress
      }
      if (address.addressNo) {
        showAddress += `เลขที่ ${address.addressNo}`
      }
      if (address.building) {
        showAddress += ` ${address.building}`
      }
      if (address.alley) {
        showAddress += ` ซอย ${address.alley}`
      }
      if (address.village) {
        showAddress += ` หมู่ที่ ${address.village}`
      }
      if (address.street) {
        showAddress += ` ถนน${address.street}`
      }
      if (address.subDistrict) {
        showAddress += ` แขวง${address.subDistrict}`
      }
      if (address.district) {
        showAddress += ` เขต${address.district}`
      }
      if (address.province) {
        showAddress += ` ${address.province}`
      }
      if (address.postCode) {
        showAddress += ` ${address.postCode}`
      }
      return showAddress
    },
    getRefDoc: function (refList) {
      if (refList.length === 0) return "-"
      let refShow = refList.map((x) => x["IssuerAssignedID"]).join(", ")
      return refShow.length > 0 ? refShow : "-"
    },
  },
  watch: {
    selectedBranch: {
      handler: function () {
        this.getData()
      },
    },
  },
}
</script>
<style lang="scss">
#report-detail {
  .text-title-month {
    font-weight: bold;
    padding-right: 10px;
  }

  table,
  th,
  td {
    border: 1px solid white;
    border-collapse: collapse;
  }

  th,
  td {
    padding: 5px;
    text-align: left;
  }

  .total-text {
    color: #6ec39b;
  }

  .title-total {
    font-size: 18px;
    font-weight: bold;
  }

  .row-header {
    background-color: #ebebeb;
  }

  .row-header-total {
    line-height: 45px;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    border: 1px solid #ddd;
  }

  .v-btn:before {
    background-color: white;
  }

  .button-select {
    background-color: white !important;
  }

  .v-input--selection-controls {
    margin: unset;
  }

  .v-messages {
    display: none;
  }

  .v-input__slot {
    margin-bottom: unset;
  }

  .foot-style {
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  }

  .test2 {
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    position: fixed;
    bottom: 0;
    //background-color: white;
    padding: 50px;
    width: 100%;
    height: 170px;
    background-color: lightgoldenrodyellow;
  }

  @media only screen and (max-width: 599px) {
    .col-response {
      flex: 0 0 100%;
    }
    .col-response-non {
      display: none;
    }
  }
}
</style>
